import { createContext } from 'react';
export var HeadingLevelContext = createContext(1);
//# sourceMappingURL=context.js.map